import { ValidationIcon_default } from "./chunk-N7RSLTZJ.js";
import { InputComponent } from "./chunk-DBD5CSY6.js";
import { Spinner_default } from "./chunk-3P5HEDZF.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Textarea/Textarea.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var TEXTAREA_CLASSNAME_MAP = {};
var Textarea = forwardRef((_a, ref) => {
  var _b = _a,
    {
      disabled,
      validation,
      isLoading,
      className
    } = _b,
    rest = __objRest(_b, ["disabled", "validation", "isLoading", "className"]);
  return /* @__PURE__ */jsxs(InputComponent, {
    disabled,
    validation,
    className: clsx("pd:textarea", validation && "pd:textarea--validation", className),
    children: [/* @__PURE__ */jsx(InputComponent.Input, __spreadValues({
      ref,
      as: "textarea",
      isLoading,
      className: clsx("pd:textarea__input", className)
    }, rest)), validation && !isLoading && /* @__PURE__ */jsx(InputComponent.Icon, {
      className: "pd:absolute pd:right-5 pd:top-3",
      children: /* @__PURE__ */jsx(ValidationIcon_default, {
        variant: validation
      })
    }), isLoading && /* @__PURE__ */jsx(InputComponent.Icon, {
      className: "pd:absolute pd:right-5 pd:top-3",
      children: /* @__PURE__ */jsx(Spinner_default, {
        variant: "primary"
      })
    })]
  });
});
var Textarea_default = Textarea;
export { TEXTAREA_CLASSNAME_MAP, Textarea_default };